import {math as polishedMath} from 'polished';
import { splitUnit } from '../bootstrap/scss/_functions';

export function math(expr) {
    const hasPercentages = /[0-9]*(\.[0-9]*)?%/.test(expr);

    if (hasPercentages) {
        expr = expr.replace(/([0-9]*(\.[0-9]*)?)%/g, (_, _1) => {
            return (+_1 / 100);
        });
    }

    const result = polishedMath(expr);

    if (hasPercentages) {
        const [num, unit] = splitUnit(result);
        return unit === "" ? `${num * 100}%` : result;
    }

    return result;
}